import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'
import type { FollowListTabNav, BetLoopProfile, BetLoopSharedBet } from '@core/Areas/BetLoop/types'
import { IncomingBetViewPostIdSearchParam } from '@core/Areas/BetLoop/Components/ProfileDisplay/constants'

export const navigateToProfileFollowingList = (
  profileId: BetLoopProfile['id'],
  isMyProfile = false
) => appHistory.push(getFollowListRoute({ profileId, listType: 'following', isMyProfile }))

export const navigateToProfileFollowersList = (
  profileId: BetLoopProfile['id'],
  isMyProfile = false
) => appHistory.push(getFollowListRoute({ profileId, listType: 'followers', isMyProfile }))

export const navigateToMyProfileWithViewBet = ({ postId }: Pick<BetLoopSharedBet, 'postId'>) =>
  appHistory.push(AppRoutes.BetLoopMyProfile + `?${IncomingBetViewPostIdSearchParam}=${postId}`)

// =============
// Local Helpers
// =============

function getFollowListRoute({
  listType,
  profileId,
  isMyProfile = false,
}: {
  listType: FollowListTabNav
  profileId: BetLoopProfile['id']
  isMyProfile: boolean
}): FollowListRoute {
  if (isMyProfile) {
    return `${AppRoutes.BetLoopMyProfileFollowList}?tab=${listType}`
  }
  return `${AppRoutes.BetLoopProfile}/${profileId}/follow-list?tab=${listType}`
}

// =====
// Types
// =====

type FollowListRoute =
  | `${typeof AppRoutes.BetLoopProfile}/${BetLoopProfile['id']}/follow-list?tab=${FollowListTabNav}`
  | `${typeof AppRoutes.BetLoopMyProfileFollowList}?tab=${FollowListTabNav}`
